import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";

const styles = theme => ({
    buttonSelector: {
        margin: "5px auto",
        display: "block"
    }
});

class PrimaryInventorySelector extends Component {
    render() {
        const { classes, inventoryCategories}= this.props;
        if (!inventoryCategories) {
            return "";
        }
        return (
            <Grid container spacing={24}>
                {inventoryCategories.map((category) => {
                    return(
                    <Grid key={category.listingCategoryId} item sm={6} xs={12}>
                        <Link style={{textDecoration: "none", color: "#FFF"}} to={"/inventory/" + category.listingCategoryId + "?pn=1"}>
                            <Button style={{width: "250px"}} className={classes.buttonSelector} variant="contained" size="large" color="primary">
                                {category.name}
                            </Button>
                        </Link>
                    </Grid>)
                    })
                }
            </Grid>);
    }
}

export default withStyles(styles)(PrimaryInventorySelector);

